import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Router} from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Toast, ToasterService } from 'angular5-toaster/dist';

interface MailChimpResponse {
    result: string;
    msg: string;
}

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.less']
})
export class SignupComponent implements OnInit {

  loader: boolean = false;
  signUpForm: FormGroup;
  showErrorDialog: boolean = false
  errorMessage = ''

  constructor(private fb: FormBuilder, private router: Router, private http: HttpClient, private toasterService: ToasterService) {
    this.signUpForm = this.fb.group({
      'EMAIL': [null, Validators.compose([Validators.required, Validators.maxLength(100), CustomValidators.email])],
      'NAME': [null, Validators.compose([Validators.maxLength(100)])],
      'COMPANY': [null, Validators.compose([Validators.maxLength(100)])],
      'MMERGE5': [null, Validators.compose([Validators.maxLength(100)])],
      'MMERGE7': [null, Validators.compose([Validators.maxLength(2000)])],
      'MMERGE8': [null, Validators.compose([Validators.maxLength(2000)])]
    });
  }

  ngOnInit() {
  }

  submitSignUpForm(e) {
    e.stopPropagation();
    for (const c in this.signUpForm.controls) {
      this.signUpForm.controls[c].markAsTouched();
    }


    if (this.signUpForm.valid) {
      this.loader = true;

      const params = new HttpParams()
      .set('EMAIL', this.signUpForm.get(['EMAIL']).value)
      .set('NAME', this.signUpForm.get(['NAME']).value)
      .set('COMPANY', this.signUpForm.get(['COMPANY']).value)
      .set('MMERGE5', this.signUpForm.get(['MMERGE5']).value)
      .set('MMERGE7', this.signUpForm.get(['MMERGE7']).value)
      .set('MMERGE8', this.signUpForm.get(['MMERGE8']).value)
      .set('b_cd1387412bc0908e2e23099d6_86db5afe05', '')

      const mailChimpSignUpUrl = 'https://noboa.us18.list-manage.com/subscribe/post-json?u=cd1387412bc0908e2e23099d6&amp;id=86db5afe05&' + params.toString()
      this.http.jsonp<MailChimpResponse>(mailChimpSignUpUrl, 'c').subscribe(response => {
        if (response.result && response.result !== 'error') {
            const toast: Toast = {
                type: 'success',
                title: 'Submit successful',
                body: "Thanks, we'll be in touch soon",
                showCloseButton: true,
                timeout: 5000
              };
  
            this.toasterService.pop(toast);
            this.router.navigate(['/']);
        }
        else {
            this.showErrorDialog = true
            this.errorMessage = response.msg
        }
        this.loader = false;
      }, error => {
        console.error(error);
        this.loader = false;
      });
    }
  }

  onGoBack() {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts